import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RobotsTopHead from './robots-top-head';
import RobotsContent from './robots-content';
import RobotsModals from './robots-modals';
import { actions as robotsActions, fetchRobotsWithFilters } from './store/slice';

const { resetFilters } = robotsActions;

const RobotsView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchRobotsWithFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => dispatch(resetFilters());
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Robots</h4>
              </div>
            </div>
            <RobotsTopHead />
          </div>
          <RobotsContent />
          <RobotsModals />
        </div>
      </div>
    </div>
  );
};

export default RobotsView;
